import { pollRegistry } from '~shared/polling';

import { extractQuestionsPollerConfig } from './extractQuestionsPollerConfig';
import { insightsPollerConfig } from './insightsPollerConfig';
import { questionsPollerConfig } from './questionsPollerConfig';

export function registerTeacherPollers() {
  pollRegistry.register(insightsPollerConfig);
  pollRegistry.register(questionsPollerConfig);
  pollRegistry.register(extractQuestionsPollerConfig);

  console.debug('[registerTeacherPollers] Registration complete');
}
